import styled from 'styled-components';

const IconSpacer = styled.div`
  padding-bottom: 16px;
`;

export { IconSpacer };
